export enum THEME_MODE {
  LIGHT = "light",
  DARK = "dark",
}

export enum SYSTEM_THEME_MODE {
  SYSTEM = "system",
}

export type ThemeMode = THEME_MODE | SYSTEM_THEME_MODE;
